(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 96808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, initialState));
    const transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 34183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(53611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(3607);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
;// CONCATENATED MODULE: ./src/constants/BiosConstants.tsx



const defaultImage = {
    src: "about/default",
    alt: "Carbon Health"
};
const useBiosConstants = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const bios = [
        {
            order: 10,
            name: "Eren Bali",
            title: i18n.t("Co-Founder & CEO"),
            ref: (0,react.useRef)(null),
            images: [
                {
                    src: "about/eren-1",
                    alt: i18n.t("Eren Bali playing in virtual reality.")
                },
                {
                    src: "about/eren-2",
                    alt: "Eren Bali"
                }
            ],
            email: "eren@carbonhealth.com",
            twitter: "@erenbali",
            linkedIn: "https://linkedin.com/in/erenbali",
            interests: [
                i18n.t("Computer science"),
                i18n.t("Mathematics"),
                i18n.t("Chess"),
                i18n.t("Physics")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Eren leads the Carbon Health team towards his vision to democratize healthcare and make quality care accessible for everyone. Previously, Eren paved the way to make education accessible by founding Udemy, the world’s largest marketplace for online courses, with over 50 million students worldwide.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "In his youth, Eren was a star mathematician, winning awards in mathematics, physics, computer science and chess including the International Mathematical Olympiads. He still loves chess today and plays to unwind after a long day at the office."
                ]
            })
        },
        {
            order: 110,
            name: "Ali Hartley",
            title: i18n.t("General Counsel"),
            ref: (0,react.useRef)(null),
            email: "ali@carbonhealth.com",
            linkedIn: "https://www.linkedin.com/in/ali-hartley-883890/",
            images: [
                {
                    src: "about/ali-1",
                    alt: i18n.t("Ali Hartley with a volleyball and swim goggles")
                },
                {
                    src: "about/ali-2",
                    alt: "Ali Hartley"
                }
            ],
            interests: [
                i18n.t("Swimming"),
                i18n.t("Hiking"),
                i18n.t("Camping"),
                i18n.t("Live country music")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Ali leads the legal and compliance functions at Carbon Health. With over 15 years of healthcare regulatory, transactional and corporate counseling experience, she brings a deep knowledge and passion for the health tech and healthcare industry. Prior to Carbon Health, Ali served as the General Counsel for The Pill Club and an Assistant General Counsel for Sutter Health.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Ali is a Bay Area native, former collegiate water polo player and outdoor enthusiast - you’ll likely find her hiking, camping or backpacking with her husband and two sons on the weekends."
                ]
            })
        },
        {
            order: 40,
            name: "An Le",
            title: i18n.t("Chief Business Officer"),
            ref: (0,react.useRef)(null),
            twitter: "@missankle",
            images: [
                {
                    src: "about/an-1",
                    alt: i18n.t('An reading a book called "ad hoc at home".')
                },
                {
                    src: "about/an-2",
                    alt: "An Le"
                }
            ],
            interests: [
                i18n.t("Surviving as a parent of two toddlers"),
                i18n.t("Homemade eats")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "An leads the enterprise strategy at Carbon Health, overseeing the go-to-market teams building direct business relationships in both the public and private sector. An has over 20 years of experience in technology and the enterprise SaaS business, most recently serving as COO of Dynamic Signal and VP of Business Development at Yammer.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "An loves food, people, and travel. Born in Thailand as a Vietnamese refugee, she immigrated to the US at the age of 3 months and has since lived in Germany, the UK, Australia, and New Zealand."
                ]
            })
        },
        {
            order: 120,
            name: "Ayo Omojola",
            title: "VP of Product",
            ref: (0,react.useRef)(null),
            email: "ayo@carbonhealth.com",
            twitter: "@ay_o",
            images: [
                {
                    src: "about/ayo-1",
                    alt: i18n.t("Ayo holding cooking utensils and the book 'Cage of Souls'")
                },
                {
                    src: "about/ayo-2",
                    alt: "Ayo Omojola"
                }
            ],
            interests: [
                i18n.t("Cooking"),
                i18n.t("Anime"),
                i18n.t("Afrobeat"),
                i18n.t("Sci-fi & fantasy")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Ayo leads the product team at Carbon Health, using technology and design thinking to find innovative solutions to increase access to healthcare. Before joining Carbon Health, Ayo was the founding product manager for the banking team for Cash App at Square, helping to scale one of the fastest growing card programs in history. An angel investor, he also seeks wildly ambitious teams that bring about positive, generation scale changes.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Ayo is known for his unconventional journeys, and even spent 1-month on a cargo ship sailing from Singapore to Brazil."
                ]
            })
        },
        {
            order: 70,
            name: "Myoung Cha",
            title: i18n.t("Chief Strategy Officer & President Home-Based Care"),
            ref: (0,react.useRef)(null),
            email: "myoung.cha@carbonhealth.com",
            twitter: "@cha_myoung",
            images: [
                {
                    src: "about/myoung-1",
                    alt: i18n.t("Myoung with a guitar")
                },
                {
                    src: "about/myoung-2",
                    alt: "Myoung Cha"
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Myoung leads Carbon Health’s device-enabled home care operations, including virtual care, remote patient monitoring, and home diagnostics services. Myoung drives the company’s omnichannel care model, which is designed to meet patients where they are by delivering care via in-person clinics, home-based care, and easy-to-use consumer health tools.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Myoung has more than a decade of healthcare experience, most recently as Apple Health’s Head of Strategic Initiatives, where he led the launch of programs like COVID-19 exposure notifications with Google, the Apple Watch–based LumiHealth wellness program, and the Heartline Study with Johnson & Johnson."
                ]
            })
        },
        {
            order: 80,
            name: "Nita Sommers",
            title: i18n.t("Chief Growth Officer"),
            ref: (0,react.useRef)(null),
            email: "nita@carbonhealth.com",
            images: [
                {
                    src: "about/nita-1",
                    alt: i18n.t("Nita with a paintbrush and palette")
                },
                {
                    src: "about/nita-2",
                    alt: "Nita Sommers"
                }
            ],
            interests: [
                i18n.t("My kids"),
                i18n.t("Painting"),
                i18n.t("Running"),
                i18n.t("Historical Literature")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Nita leads new strategic growth initiatives, focused on expanding Carbon Health’s services into areas such as mental health, nutrition, and pediatrics, as well as building out Carbon Health's value-based offerings for employers and payers.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Nita previously served as the President of Honor, a provider of home-based care to older adults, and she spent nearly seven years as Chief Strategy Officer at Castlight Health, a health navigation platform for employers and health plans. She was also an early member of the Athenahealth team, and was most recently an Operating Partner for Khosla Ventures, where she worked with the firm’s portfolio of early-stage companies transforming healthcare."
                ]
            })
        },
        {
            order: 30,
            name: "Caesar Djavaherian, MD",
            title: i18n.t("Co-Founder, Chief Clinical Innovation Officer"),
            ref: (0,react.useRef)(null),
            twitter: "@caesardjava",
            email: "caesar@carbonhealth.com",
            images: [
                {
                    src: "about/caesar-1",
                    alt: i18n.t("Caesar with a snowboard")
                },
                {
                    src: "about/caesar-2",
                    alt: "Caesar Djavaherian, MD"
                }
            ],
            interests: [
                i18n.t("Snowboarding"),
                i18n.t("Biohacking"),
                i18n.t("Evidence-based Medicine")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Caesar brings clinical innovation to Carbon Health through technology, product development, and partnerships with transformative companies that improve the healthcare ecosystem. He is an emergency medicine physician, former high school teacher, and a reformed academic researcher. Prior to Carbon Health, Caesar co-founded Direct Urgent Care to deliver technology-enabled urgent care throughout the SF Bay Area. He began his career at New York-Presbyterian Hospital, The University Hospital of Columbia, and Weill Cornell Medicine.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "In his spare time, Caesar advises healthcare startups, cheers on the Warriors, tries various HIIT workouts and daydreams about what the future will look like."
                ]
            })
        },
        {
            order: 130,
            name: "Carrie Douglas",
            title: i18n.t("General Manager, Clinics"),
            ref: (0,react.useRef)(null),
            email: "carrie@carbonhealth.com",
            interests: [
                i18n.t("Camping"),
                i18n.t("Traveling"),
                i18n.t("Swimming")
            ],
            images: [
                {
                    src: "about/carrie-1",
                    alt: i18n.t("Carrie with cooking utensils")
                },
                {
                    src: "about/carrie-2",
                    alt: "Carrie Douglas"
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Carrie leads the clinic teams who provide care every day to Carbon Health's patients. She is passionate about leading teams, teaching, coaching, and helping others grow and has spent her career in healthcare operations and leadership roles. Prior to Carbon Health, Carrie was with One Medical for over 10 years, as well as an early stage startup focused on value-based care for seniors.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Carrie loves hosting gatherings for friends and her large family - she is one of five kids! She has an amazing husband and two children, who all love to spend time outdoors."
                ]
            })
        },
        {
            order: 50,
            name: "Claire Hough",
            title: i18n.t("Chief Technology Officer"),
            ref: (0,react.useRef)(null),
            email: "claire@carbonhealth.com",
            images: [
                {
                    src: "about/claire-1",
                    alt: i18n.t("Claire wearing boxing gloves")
                },
                {
                    src: "about/claire-2",
                    alt: "Claire Hough"
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Claire leads engineering at Carbon Health, bringing over 25 years of experience as a technology leader. She has helped over a half dozen companies grow and scale to deliver impact-driving products and services, including Netscape, Napster, Nextag, and Udemy. She has been named one of San Francisco Business Times' Most Influential Women in Bay Area Business.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Claire lives in Palo Alto with her husband, two children, and a french bulldog named Tobiwan Kenobi. She loves saying hello to babies and dogs. Her husband, Tim, believes she knows every dog in Palo Alto."
                ]
            })
        },
        {
            order: 140,
            name: "Kerem Ozkay",
            title: i18n.t("SVP of Marketing"),
            ref: (0,react.useRef)(null),
            email: "kozkay@carbonhealth.com",
            twitter: "@kozkay",
            interests: [
                i18n.t("Photography"),
                i18n.t("Hiking & nautre"),
                i18n.t("Fishing")
            ],
            images: [
                {
                    src: "about/keremo-1",
                    alt: i18n.t("Kerem holding a camera")
                },
                {
                    src: "about/keremo-2",
                    alt: i18n.t("Kerem Ozkay")
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Through innovative campaigns and initiatives, Kerem and his team continue to push the boundaries of what people think healthcare is and what it could be. Kerem brings more than 15 years of experience in data-driven, direct-to-consumer advertising, and omnichannel marketing and is passionate about furthering Carbon Health's mission of making high-quality healthcare accessible. Previously the VP of marketing at Z Gallerie, Kerem offers unique insights from the world of retail.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Kerem loves photography (astrophotography is a particular area of interest), all kinds of fishing, and spending time with the family."
                ]
            })
        },
        {
            order: 150,
            name: "Kerem Suer",
            title: "VP of Design",
            ref: (0,react.useRef)(null),
            email: "kerem@carbonhealth.com",
            images: [
                {
                    src: "about/kerems-1",
                    alt: i18n.t("Kerem in a life vest")
                },
                {
                    src: "about/kerems-2",
                    alt: i18n.t("Kerem Suer")
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Kerem oversees the design team at Carbon Health, bringing his wealth of experience in designing products and brands such as Fitbit, Omada Health and MyFitnessPal. He is an interdisciplinary designer that creates and defines visual and interactive design systems across web, mobile and desktop.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Kerem’s curious nature comes from his unique life adventures, starting with his time in the Turkish National Sailing Team. He then moved to a little town of 2,000 in Oklahoma as an exchange student, and has been exploring the US and the world since."
                ]
            })
        },
        {
            order: 160,
            name: "Roger Wu, MD",
            title: "Medical Director, Clinics",
            ref: (0,react.useRef)(null),
            email: "roger@carbonhealth.com",
            twitter: "@RWuMD",
            interests: [
                i18n.t("Climbing"),
                i18n.t("Cycling"),
                i18n.t("Surfing"),
                i18n.t("Clinical education")
            ],
            images: [
                {
                    src: "about/roger-1",
                    alt: i18n.t("Roger in gi")
                },
                {
                    src: "about/roger-2",
                    alt: i18n.t("Roger Wu")
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Roger works to optimize the patient-provider relationship at Carbon Health for seamless, compassionate bedside care. As a practicing physician and leader, he enjoys living at the intersection of medicine, leadership, technology, and systems design. Roger is board-certified in Emergency Medicine, and prior to Carbon Health, served as an emergency department medical director at TeamHealth, where he was awarded Medical Director of the Year.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Outside of medicine, he can be found on the mats at his local Brazilian jiu-jitsu gym in San Francisco or exploring the outdoors with his wife and son."
                ]
            })
        },
        {
            order: 20,
            name: "Russ Fradin",
            title: i18n.t("Vice Chairman"),
            ref: (0,react.useRef)(null),
            email: "russ@carbonhealth.com",
            images: [
                {
                    src: "about/russ-1",
                    alt: i18n.t("Russ sitting with his phone.")
                },
                {
                    src: "about/russ-2",
                    alt: "Russ Fradin"
                }
            ],
            twitter: "@rfradin",
            interests: [
                i18n.t("His kids"),
                i18n.t("Running"),
                i18n.t("The entire Keanu Reeves catalog")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_i18n/* Trans */.cC, {
                children: "Russ is a technology founder, executive, and investor who has been working across the startup industry since 1996. Based in Silicon Valley, Russ currently serves as Vice Chairman of Carbon Health where he works with Eren and the leadership team to support Carbon Health's historic growth. Russ is also the Chairman of Dynamic Signal, a venture backed SaaS business he founded and ran as CEO for ten years. Prior to founding Dynamic Signal, he was the founder and CEO of Adify, which he sold to Cox Enterprises in 2008. Russ is also on the board of CoachArt, a non-profit in California."
            })
        },
        {
            order: 90,
            name: "Sujal Mandavia, MD",
            title: i18n.t("Chief Medical Officer"),
            ref: (0,react.useRef)(null),
            email: "sujal@carbonhealth.com",
            interests: [
                i18n.t("Hocket"),
                i18n.t("Hiking"),
                i18n.t("listening to The Tragically Hip")
            ],
            images: [
                {
                    src: "about/sujal-1",
                    alt: i18n.t("Sujal with a stethoscope")
                },
                {
                    src: "about/sujal-2",
                    alt: i18n.t("Sujal Mandavia")
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Sujal oversees all clinical operations and protocols, as well as the expansion of Carbon Health’s high-quality clinical care offering. Actively practicing for over 20 years, Sujal brings a wealth of healthcare management experience and has served as an examiner for the American Board of Emergency Medicine and on the board of the California ACEP (American College of Emergency Physicians). He most recently served as Senior Vice President at TeamHealth, where he supported 2,000 providers across the western U.S.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "When not at work, Sujal enjoys everything hockey related, listening to the Tragically Hip, and being taken for hikes by his Rhodesian Ridgebacks."
                ]
            })
        },
        {
            order: 95,
            name: "Uzair Qadeer",
            title: i18n.t("Chief People Officer"),
            ref: (0,react.useRef)(null),
            email: "uzair.qadeer@carbonhealth.com",
            interests: [
                i18n.t("Fashion"),
                i18n.t("International travel"),
                i18n.t("Learning new languages")
            ],
            linkedIn: "https://www.linkedin.com/in/uzairqadeer",
            images: [
                {
                    src: "about/uzair-1",
                    alt: i18n.t("Uzair holding a globe")
                },
                {
                    src: "about/uzair-2",
                    alt: i18n.t("Uzair Qadeer")
                }
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Uzair leads the company’s end-to-end human resources capabilities including talent discovery and development, diversity and inclusion, total rewards, employee experience, people operations, learning, and development as it continues to scale to become the largest nationwide primary care provider. Uzair’s talent for deeply connecting employees to patients creates a meaningful environment where all Carbonauts - employees, providers, clinicians and patients - feel a deep sense of belonging that inspires innovation for improving our patient’s lives everyday.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Prior to Carbon Health, Qadeer was Chief Diversity Officer at Alexion Pharmaceuticals where he built a global diversity and inclusion program from the ground up. Before that, he worked at Deloitte’s human capital consulting business where he focused on redefining every aspect of HR, including organizational development, culture, and talent management. He was named Top 100 Chief Diversity Officers by the National Diversity Council."
                ]
            })
        },
        {
            order: 100,
            name: "Will Abbott",
            title: i18n.t("Chief Operating Officer"),
            ref: (0,react.useRef)(null),
            email: "will@carbonhealth.com",
            twitter: "@citizen_jw",
            images: [
                {
                    src: "about/will-1",
                    alt: i18n.t("Will pouring coffee")
                },
                {
                    src: "about/will-2",
                    alt: "Will Abbott"
                }
            ],
            interests: [
                i18n.t("Cooking"),
                i18n.t("Duke basketball"),
                i18n.t("Retro video games")
            ],
            bio: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Will is the steady-handed leader of the clinic, virtual care and operations teams at Carbon Health. He takes special pride in being a steward of Carbon Health’s culture and creating an inclusive, supportive and empowering environment for both Carbon Health patients and his fellow Carbonauts. Prior to joining Carbon Health, Will had a long and successful career with CVS Health, serving on its leadership team in a variety of operational roles.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Outside of work, Will spends his days with his wife, chasing their preschool-aged daughter around various playgrounds in the Bay Area, or working on entirely unnecessary electronics projects."
                ]
            })
        }
    ].map((bio)=>({
            ...bio,
            images: bio.images.length ? bio.images : [
                defaultImage
            ]
        }));
    return {
        bios
    };
};
/* harmony default export */ var BiosConstants = (useBiosConstants);

// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/components/v5/Modal.tsx
var Modal = __webpack_require__(27591);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(48489);
;// CONCATENATED MODULE: ./src/components/_common/LazyImg.tsx



const LazyImg = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
        ...props
    });

// EXTERNAL MODULE: ./src/useV5ImgSrc.tsx
var useV5ImgSrc = __webpack_require__(52299);
;// CONCATENATED MODULE: ./src/components/v5/About/BioCard.tsx






// eslint-disable-next-line react/display-name
const BioCard = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { index , person , toggleActiveIndex  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const firstImage = person.images[0] || defaultImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        role: "button",
        tabIndex: 0,
        style: {
            "--br": 0.5
        },
        className: "df fdc mb10 cp w58 w48-sm w100p-xs focus-bsDarkBlue3 mr2 mb2 m0-xs",
        "aria-label": i18n.t("Open profile for {{name}}", {
            name: person.name
        }),
        onKeyDown: (e)=>e.key === "Enter" && toggleActiveIndex(index)(),
        onClick: toggleActiveIndex(index),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImg, {
                className: "br2 mb3 h72 h40-md obfc",
                src: (0,useV5ImgSrc/* useV5ImgSrc */.eH)("/".concat(firstImage.src || "default")),
                "aria-label": firstImage.alt,
                alt: firstImage.alt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-mr ttu mb1 fs12 lh15",
                style: {
                    letterSpacing: 0.7
                },
                children: person.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-cm fs20",
                style: {
                    letterSpacing: -0.3
                },
                children: person.name
            })
        ]
    }, person.name);
});
/* harmony default export */ var About_BioCard = (BioCard);

// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/react-swipeable/es/index.js
var es = __webpack_require__(96808);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/useEscape.ts
var useEscape = __webpack_require__(58689);
;// CONCATENATED MODULE: ./src/components/v5/ImageFlipper.tsx






const ImageFlipper = (param)=>{
    let { imageList  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const stagedIndex = activeIndex + 1 < imageList.length ? activeIndex + 1 : 0;
    const firstImage = imageList[activeIndex];
    const firstImageSrc = (0,useV5ImgSrc/* useV5ImgSrc */.eH)(firstImage === null || firstImage === void 0 ? void 0 : firstImage.src);
    const stagedImage = imageList.length > 1 && imageList[stagedIndex];
    // @ts-expect-error TS2339: Property 'src' does not exist on type 'false | ImageItem'.
    const stagedImageSrc = (0,useV5ImgSrc/* useV5ImgSrc */.eH)((stagedImage === null || stagedImage === void 0 ? void 0 : stagedImage.src) || "");
    const showNextItem = ()=>setActiveIndex(stagedIndex);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hfc minw24 minh120 pl6 pr6 pos-r",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pos-r cp focus-bsDarkBlue3 h120 w100",
                style: {
                    "--br": 1
                },
                role: "button",
                onClick: showNextItem,
                onKeyDown: (e)=>e.key === "Enter" && showNextItem(),
                tabIndex: 0,
                "aria-label": i18n.t("View next photo"),
                children: [
                    firstImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pos-a-f zIndex1",
                        style: {
                            top: 0,
                            left: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImg, {
                            src: firstImage.absSrc || firstImageSrc,
                            "aria-label": firstImage.alt,
                            alt: firstImage.alt,
                            className: "bs1 br3 obfc h110 w90"
                        }, firstImage.src)
                    }),
                    stagedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pos-a zIndex0",
                        style: {
                            top: 20,
                            right: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImg, {
                            src: stagedImage.absSrc || stagedImageSrc,
                            "aria-label": stagedImage.alt,
                            alt: stagedImage.alt,
                            className: "bs1 br3 h110 w90"
                        }, stagedImage.src)
                    })
                ]
            }),
            stagedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pos-a ma",
                style: {
                    bottom: -20,
                    left: 0,
                    right: 0
                },
                children: imageList.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "br50 dib mr3 h3 w3 cp t-200",
                        "aria-label": i18n.t("View the image at this position in the stack"),
                        onClick: ()=>{
                            setActiveIndex(i);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") {
                                setActiveIndex(i);
                            }
                        },
                        style: {
                            backgroundColor: i === activeIndex ? palette.gray600 : palette.gray200
                        }
                    }, "circle-".concat(item.src)))
            })
        ]
    });
};
/* harmony default export */ var v5_ImageFlipper = (ImageFlipper);

// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/About/Profile.tsx











const Profile = (param)=>{
    let { activeIndex , setActiveProfile , total , closeRef , lastItemRef , closingFocusRef , person: { title , name , bio , email , linkedIn , twitter , interests , images  }  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { imgExt , isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const swipeHandlers = (0,es/* useSwipeable */.QS)({
        onSwipedLeft: setActiveProfile.next,
        onSwipedRight: setActiveProfile.prev
    });
    (0,useEscape/* useKeyHandler */.yN)("ArrowRight", setActiveProfile.next);
    (0,useEscape/* useKeyHandler */.yN)("ArrowLeft", setActiveProfile.prev);
    (0,useEscape/* useKeyHandler */.yN)("Escape", ()=>{
        setActiveProfile.none();
        if (closingFocusRef.current) {
            closingFocusRef.current.focus();
        }
    });
    const buttonDimensions = {
        height: 20,
        width: 20
    };
    const buttonClasses = "br50 gray800 white-sm p5 bg-white bg-gray800-sm ml3 cp df aic jcc fs26 focus-bsDarkBlue3";
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const keyDownHandler = (e)=>{
        if (e.key === "Enter") {
            setActiveProfile.next();
        }
        // @ts-expect-error TS2532: Object is possibly 'undefined'.
        if (!e.shiftKey && e.key === "Tab" && closeRef.current) {
            // @ts-expect-error TS2532: Object is possibly 'undefined'.
            closeRef.current.focus();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df fdc-sm ph8 ph2-md pv6 ph0-sm hide-scroll-bars maxw20-sm",
        children: [
            isMobile || isSm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "df pos-r w140 ovf-x-a ma mb6 pl30",
                style: {
                    right: 120
                },
                children: [
                    images.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImg, {
                            src: "/static/img/v5/".concat(item.src, ".").concat(imgExt),
                            "aria-label": item.alt,
                            alt: item.alt,
                            className: "br3 obfc oh h48 minw16 mr3"
                        }, "".concat(i, "-").concat(item.src))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "minw4 minh10"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pr14",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_ImageFlipper, {
                    imageList: images
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tal w100 w80-md pr2-sm",
                ...swipeHandlers,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-mr ttu lh13 fs12",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-csb fs48 fs".concat(name.length > 17 ? "24-sm lh14" : "32-sm", " mb3 fs40-md lh1 mt2"),
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb8 mb3-md df aic fw",
                        children: [
                            email && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                className: "focus-bsDarkBlue3 mr1 mb1 event-XOLuHZ-".concat(name),
                                bg: palette.gray100,
                                hoverBg: palette.gray50,
                                color: palette.gray800,
                                fontSize: 0.75,
                                href: "mailto:".concat(email),
                                "aria-label": i18n.t("Send an email to {{name}}", {
                                    name
                                }),
                                children: email
                            }),
                            linkedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                className: "focus-darkBlue3 p3-f focus-bsDarkBlue3 mr1 mb1 event-n9JmcB-".concat(name),
                                bg: palette.gray100,
                                hoverBg: palette.gray50,
                                color: palette.gray800,
                                fontSize: 0.75,
                                href: linkedIn,
                                "aria-label": i18n.t("Go to the LinkedIn page of {{name}}", {
                                    name
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cIcon-linkedin fs16"
                                })
                            }),
                            twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                className: "focus-darkBlue3 p3-f focus-bsDarkBlue3 event-MAD8mt-".concat(name),
                                bg: palette.gray100,
                                hoverBg: palette.gray50,
                                color: palette.gray800,
                                fontSize: 0.75,
                                href: "https://twitter.com/".concat(twitter.replace("@", "")),
                                "aria-label": i18n.t("Go to the Twitter feed of {{name}}", {
                                    name
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cIcon-twitter fs16"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ovf-y-a mb10",
                        style: {
                            maxHeight: "40vh"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs14 font-ir m0 p0",
                                children: bio
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "minh10"
                            })
                        ]
                    }),
                    interests && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dn-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "db font-mr ttu fs12 mb2",
                                children: i18n.t("Interests")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-ib fs12",
                                children: interests.join("  /  ")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pos-a m4-sm right0 white gray800-sm df aic jcfe",
                style: {
                    bottom: isSm ? 50 : -55
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-mb fs12",
                        children: i18n.t("{{number}} of {{total}}", {
                            number: activeIndex + 1,
                            total
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "button",
                        className: buttonClasses,
                        "aria-label": i18n.t("Go to previous profile"),
                        style: buttonDimensions,
                        tabIndex: 0,
                        onClick: setActiveProfile.prev,
                        onKeyDown: (e)=>e.key === "Enter" && setActiveProfile.prev(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cIcon-arrow-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "button",
                        ref: lastItemRef,
                        className: buttonClasses,
                        "aria-label": i18n.t("Go to next profile"),
                        style: buttonDimensions,
                        tabIndex: 0,
                        onClick: setActiveProfile.next,
                        onKeyDown: keyDownHandler,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cIcon-arrow-right2"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var About_Profile = (Profile);

// EXTERNAL MODULE: ./src/components/v5/About/SectionHeader.tsx
var SectionHeader = __webpack_require__(9978);
;// CONCATENATED MODULE: ./src/components/v5/About/Bios.tsx









const Bios = ()=>{
    var _bios_activeIndex;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { bios  } = BiosConstants();
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | (() => number)'.
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const [shouldAutoFocus, setShouldAutoFocus] = (0,react.useState)(true);
    const toggleActiveIndex = (index)=>()=>{
            if (Number.isInteger(index)) {
                setShouldAutoFocus(true);
            } else {
                setShouldAutoFocus(false);
            }
            // @ts-expect-error TS2345: Argument of type 'number | null | undefined' is not assignable to parameter of type 'SetStateAction<number>'.
            setActiveIndex(Number.isInteger(index) ? index : null);
        };
    const setActiveProfile = {
        none: toggleActiveIndex(),
        next: toggleActiveIndex(activeIndex + 1 > bios.length - 1 ? 0 : activeIndex + 1),
        prev: toggleActiveIndex(activeIndex - 1 < 0 ? bios.length - 1 : activeIndex - 1)
    };
    const closingFocusRef = (_bios_activeIndex = bios[activeIndex]) === null || _bios_activeIndex === void 0 ? void 0 : _bios_activeIndex.ref;
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const closeButtonStyle = isSm && {
        top: 80,
        backgroundColor: "white"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "our-leaders",
        className: "ph8 pt24 pt20-sm pb10 ph4-xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "maxw80 ma",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb15 mb6-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* default */.Z, {
                            tag: i18n.t("Who we are"),
                            header: i18n.t("Our leaders")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "df dg-xs af fw gg2-xs",
                        style: {
                            "--w": "140px"
                        },
                        children: bios.sortBy((param)=>{
                            let { order  } = param;
                            return order;
                        }).map((person, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(About_BioCard, {
                                ref: person.ref,
                                person: person,
                                index: i,
                                toggleActiveIndex: toggleActiveIndex
                            }, person.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                "aria-modal": true,
                className: "br3-f w100vw-sm h100vh-sm br0-f-sm df-sm pt10-sm jcc-sm",
                innerClasses: "p0-f-sm",
                active: Number.isInteger(activeIndex),
                // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | undefined'.
                onClickOutside: toggleActiveIndex(null),
                shouldAutoFocus: shouldAutoFocus,
                closeFocusRef: closingFocusRef,
                closeButtonStyle: closeButtonStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(About_Profile, {
                    total: bios.length,
                    person: bios.sortBy((param)=>{
                        let { order  } = param;
                        return order;
                    })[activeIndex],
                    activeIndex: activeIndex,
                    setActiveProfile: setActiveProfile,
                    closingFocusRef: closingFocusRef
                })
            })
        ]
    });
};
/* harmony default export */ var About_Bios = (Bios);

// EXTERNAL MODULE: ./src/components/v5/About/Careers.tsx + 1 modules
var Careers = __webpack_require__(3497);
// EXTERNAL MODULE: ./src/components/v5/About/CoreValues.tsx
var CoreValues = __webpack_require__(77544);
// EXTERNAL MODULE: ./src/components/v5/About/AboutUs.tsx
var AboutUs = __webpack_require__(15897);
// EXTERNAL MODULE: ./src/components/v5/About/Hero.tsx
var Hero = __webpack_require__(4448);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
;// CONCATENATED MODULE: ./src/pages/about-us.tsx












const About = (param)=>{
    let { jobs =[]  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("About Us | Carbon Health"),
        pageImage: "about-us-mint",
        navTheme: useNavState/* NavTheme.LIGHT */.Xm.LIGHT,
        wrapClasses: "ovf-unset" // required for position sticky to work
        ,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                jobCount: jobs.length
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreValues/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About_Bios, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Careers/* default */.Z, {
                jobs: jobs
            })
        ]
    });
};
About.getInitialProps = async ()=>{
    const jobs = await fetch(_constants/* LEVER_URI */.LK).then((res)=>res.json()).catch((err)=>{
        esm_exports/* captureException */.Tb(err);
        return [];
    });
    return {
        jobs
    };
};
/* harmony default export */ var about_us = (About);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,4690,6282,2122,5280,9774,2888,179], function() { return __webpack_exec__(34183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);